(function () {
  'use strict';

  angular
      .module('tfc.sso.Auth')
      .factory('CookieJar', CookieJar);

  // @ngInject
  function CookieJar($log) {

    return {
      /**
       * @name CookieJar#get
       * @param name {string} The name of the cookie
       * @returns {string} The value of the cookie, or undefined if it does not exist.
       */
      get : get,
      /**
       * @name CookieJar#set
       * @param {object} data The cookie configuration, which has the following fields:
       *      - {string} name The name of the cookie.
       *      - {string} value The value of the cookie.
       *      - {string} [domain] The domain for the cookie. Setting to true will use the current domain's parent domain.
       *                          Omitting the domain sets a session cookie.
       *      - {string} [path] The path to which this cookie applies. Defaults to '/'.
       *      - {number} [maxAge] Integer representing # seconds for the cookie to last. Anything <= 0 will delete the cookie.
       */
      set : set,
      /**
       * @name CookieJar#remove
       * @param {object|string} data The name of the cookie, or an object containing:
       *      - {string} name The name of the cookie.
       *      - {string} [domain] The domain of the cookie. Defaults to the current domain's parent domain.
       *      - {string} [path] The path of the cookie to delete. Defaults to '/'.
       */
      remove : remove
    };

    function isNonEmptyString(x) {
      return _.isString(x) && x.length > 0;
    }

    function defaultDomain() {
      var domain = location.hostname;
      if (domain === 'localhost') {
        $log.warn("Cookies don't really work on localhost. Using a session cookie");
        return;
      }
      var parts = domain.split('.');
      if (parts.length > 2) {
        return parts.slice(1).join('.');
      } else {
        return domain;
      }
    }

    function get(name) {
      var cookiePairs = document.cookie.split('; ');
      var value;
      _.each(cookiePairs, function (pair) {
        var split = pair.split('=');
        if (split[0] === name) {
          value = split[1];
          return false;
        }
      });
      return value;
    }

    function set(data) {
      var cookie, expires;
      if (_.isPlainObject(data) && _.isString(data.name) && _.isString(data.value)) {

        cookie = data.name + '=' + data.value;

        if (data.domain === true) {
          data.domain = defaultDomain();
        }

        if (isNonEmptyString(data.domain)) {
          cookie += ';domain=' + data.domain;
        }

        data.path = isNonEmptyString(data.path) ? data.path : '/';
        cookie += ';path=' + data.path;

        if (!isNaN(data.maxAge)) {
          if (data.maxAge <= 0) {
            data.maxAge = expires = 0;
          } else {
            expires = new Date().getTime() + data.maxAge * 1000;
          }
          cookie += ';max-age=' + data.maxAge;
          cookie += ';expires=' + new Date(expires).toUTCString();
        }

        document.cookie = cookie;
      }
    }

    function _remove(data) {
      set({
        name: data.name,
        value: '',
        domain: data.domain,
        path: data.path,
        maxAge: 0
      });
    }

    function remove(data) {
      if (_.isString(data)) {
        data = {
          name : data,
          domain : true
        };
      }

      _remove(data);

      if (get(data.name) != null && data.domain) {
        $log.debug('Cookie [' + data.name + '] still present after remove. ' +
            'Trying again as a session cookie');
        delete data.domain;
        _remove(data);
      }
    }
  }

})();
